// Do not delete this file. linced-enrolments is a public app and has no OAuth
// config. This empty initializer replaces the linced-common oauth2
// initializer (same path), which reads config.oauth at boot and fails without
// it.
export function initialize(): void {
  // Nothing to set up.
}

export default {
  initialize,
};
